import { createSelector } from 'reselect'

import { selectConfigurationState } from './selectConfigurationState'

export const selectPartner360Data = createSelector([selectConfigurationState], ({ data }) => data)
